import React, { createContext, PropsWithChildren, useContext, useEffect, useState } from "react"

import { Context, CustomerInfoService } from "./types"

const CustomerInfoContext = createContext({} as Context)

export const useCustomerInfo = () => useContext(CustomerInfoContext)

// TODO: REFACTOR. This provider basically is the same as GlobalSettingsProvider.
//  But the GlobalSettingsProvider better to be refactored and merged with this CustomerInfoProvider.
//  Postponed because there's not enough time to do that now properly
export const CustomerInfoProvider = ({ children, service }: PropsWithChildren & { service: CustomerInfoService }) => {
  const [state, setState] = useState<Context>({
    loading: false, data: null, error: null
  })

  useEffect(() => {
    (async () => {
      try {
        setState((prev) => ({...prev, loading: true, error: null}))
        const {data} = await service.getCustomerInfo()
        setState({loading: false, data, error: null})
      } catch (error) {
        setState((prev) => ({...prev, loading: false, error}))
      }
    })()
  }, [])
  
  return (<CustomerInfoContext.Provider value={state}>
    {children}
  </CustomerInfoContext.Provider>)
}
